export const searchWaste = () => {
	const searchInput = document.querySelector('.waste .search__input');

	if (!searchInput) {
		return;
	}

	const wasteItems = Array.from(document.querySelectorAll('.waste .cell__li'));
	const initialActiveItems = new Set(
		wasteItems.filter((item) => item.classList.contains('cell__li--active'))
	);

	const normalizeValue = (value) => value.toLowerCase().replace(/\s+/g, '');

	const updateHighlightedItems = () => {
		const query = normalizeValue(searchInput.value.trim());

		wasteItems.forEach((item) => {
			const itemValue = normalizeValue(item.textContent || '');
			const isMatch = query === ''
				? initialActiveItems.has(item)
				: itemValue.includes(query);

			item.classList.toggle('cell__li--active', isMatch);
		});
	};

	searchInput.addEventListener('input', updateHighlightedItems);
	updateHighlightedItems();
}